/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useReducer, useEffect } from 'react';
import defer from 'hs-promise-utils/defer';
import { RequestStatus } from '../../../api/constants';
import { getBrowserCategoriesCache, getBrowserFieldsCache } from 'rich-text-lib/utils/buildProperties';
const getInitialState = () => {
  return {
    requestStatus: RequestStatus.UNINITIALIZED,
    categories: [],
    fieldsByCategory: {}
  };
};
const fetchPathsReducer = (state, {
  requestStatus,
  categories,
  fieldsByCategory
}) => {
  switch (requestStatus) {
    case RequestStatus.PENDING:
      return Object.assign({}, state, {
        requestStatus
      });
    case RequestStatus.SUCCEEDED:
      return {
        requestStatus,
        categories,
        fieldsByCategory
      };
    case RequestStatus.FAILED:
      return Object.assign({}, state, {
        requestStatus
      });
    default:
      return state;
  }
};
export const usePaths = (fetchPaths, personalizeConfig) => {
  // useReducer allows us to guarantee requestStatus is set to SUCCEEDED
  // at the exact same time as paths is set to the API response;
  // were we to simply use two useState hooks, there would be an interstitial
  // tick between the first useState call and the second, which would mean that
  // our requestStatus state is desynced from the actual request value itself
  const initialState = getInitialState();
  const [{
    requestStatus,
    categories,
    fieldsByCategory
  }, dispatch] = useReducer(fetchPathsReducer, initialState);
  useEffect(() => {
    if (!fetchPaths) return undefined;
    const deferredRequest = defer();
    dispatch({
      requestStatus: RequestStatus.PENDING
    });
    fetchPaths(personalizeConfig).then(deferredRequest.resolve);
    deferredRequest.promise.then(() => {
      dispatch({
        requestStatus: RequestStatus.SUCCEEDED,
        categories: getBrowserCategoriesCache(personalizeConfig),
        // valid after fetchPaths returns
        fieldsByCategory: getBrowserFieldsCache(personalizeConfig) // valid after fetchPaths returns
      });
    }).catch(err => {
      dispatch({
        requestStatus: RequestStatus.FAILED
      });
      console.warn(err);
    });
    return () => {
      deferredRequest.reject('[rich-text-lib][personalization][fetchPaths] component unmounting abort state update');
    };
  }, [fetchPaths, personalizeConfig]);
  return [{
    categories,
    fieldsByCategory
  }, requestStatus];
};